// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32bc8d24","770":"b477def6"}[chunkId] + ".chunk.js";
};